export default "__VITE_ASSET__f39d8f21__"